(function () {
    jQuery(document).ready(function ($) {
        $(".toggle-submenu").on("click", function (e) {
            e.preventDefault(); //detiene el evento de envio

            var $target = $("#" + $(this).data("target"));
            var $svg = $(this).find("svg");

            if ($target.length) {
                $target.toggleClass("uk-hidden");

                if ($svg.length) {
                    if ($target.hasClass("uk-hidden")) {
                        $svg.removeClass("sw-arrow-up").addClass("sw-arrow-down");
                    } else {
                        $svg.removeClass("sw-arrow-down").addClass("sw-arrow-up");
                    }
                }
            }
        });
    });
})();